'use client';

import { InverseHeader } from '@jouzen/ecom-components/layout';

import useScrollTracking from '@/app/hooks/useScrollTracking';

import PartnershipsCards from './_components/PartnershipsCards';
import PartnershipsExperience from './_components/PartnershipsExperience';
import PartnershipsFooter from './_components/PartnershipsFooter';
import PartnershipsHero from './_components/PartnershipsHero';
import PartnershipsIntegrations from './_components/PartnershipsIntegrations';
import PartnershipsJourney from './_components/PartnershipsJourney';
import PartnershipsMember from './_components/PartnershipsMember';
import PartnershipsOfferings from './_components/PartnershipsOfferings';

const Content = () => {
  // scroll depth tracking hook for segment analytics
  useScrollTracking();

  return (
    <section>
      <InverseHeader enter>
        <PartnershipsHero />
      </InverseHeader>
      <PartnershipsOfferings />
      <PartnershipsExperience />
      <PartnershipsCards />
      <PartnershipsMember />
      <PartnershipsJourney />
      <PartnershipsIntegrations />
      <PartnershipsFooter />
    </section>
  );
};

export default Content;
